export default [
  {
    path: '/user/login',
    name: 'userLogin',
    component: () => import(/* webpackChunkName: "user" */'./views/login')
  }
]
